import { render, staticRenderFns } from "./juzgado.vue?vue&type=template&id=23663cd2&scoped=true"
import script from "./juzgado.vue?vue&type=script&lang=js"
export * from "./juzgado.vue?vue&type=script&lang=js"
import style0 from "./juzgado.vue?vue&type=style&index=0&id=23663cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23663cd2",
  null
  
)

export default component.exports